document.addEventListener("DOMContentLoaded", function () {
  var targetNode = document.body;
  var count = 0;
  var observer = new MutationObserver(function (mutationsList, observer) {
    var inputElement = document.getElementById("autocomplete-0-input");
    if (inputElement) {
      count++;
      inputElement.setAttribute("placeholder", "Search");
      if (count >= 5) {
        observer.disconnect();
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });
});
